export default __webpack_public_path__ + "static/media/11_Itziar.bf6fbab5.webp";